import { cn } from '@distribute/frontend/utils';
import { forwardRef } from 'react';

export type BubbleMenuToolbarProps = {
  children: React.ReactNode;
  isDarkTheme?: boolean;
};

export const BubbleMenuToolbar = forwardRef<
  HTMLDivElement,
  BubbleMenuToolbarProps
>(({ children, isDarkTheme = false }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'flex items-center gap-1 p-1 h-9 border  rounded-lg  shadow-md',
        {
          'border-gray-200 bg-base-white': !isDarkTheme,
          'bg-gray-800 border-gray-800': isDarkTheme,
        }
      )}
    >
      {children}
    </div>
  );
});
